import MyHistoryPage from 'components/organisms/my_history_page';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFollowups, getMyHistory } from 'store/modules/my_history_store/actions';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import { ProfileState } from 'store/modules/profile_store/types';
import { ApplicationState } from 'store';
import companyId from 'services/company_id';
import tabId from 'services/tabId';
import BlockedSubscriptionRepresentant from 'components/molecules/blocked_subscription_representant';

interface IHandleDatesChange {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}
const MyHistory = () => {
  const dispatch = useDispatch();
  const [pageFollowup, setPageFollowup] = useState<number>(1);
  const [pageItens, setPageItens] = useState<number>(1);
  const [filtro, setFiltro] = useState<string>('all');
  const [startDate, setStartDate] = useState<moment.Moment | null>(null);
  const [endDate, setEndDate] = useState<moment.Moment | null>(null);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const urlFollowup = '/mercado/get_followups_my_history';

  const allowedSaleSituations = ['Ativa', 'Em Analise'];

  useEffect(() => {
    document.title = 'Meu Histórico - ConLicitação';
    dispatch(
      getFollowups(
        pageFollowup,
        filtro,
        urlFollowup,
        companyId(profile),
        null,
        startDate && startDate.format('YYYY-MM-DD'),
        endDate && endDate.format('YYYY-MM-DD'),
      ),
    );
  }, [pageFollowup, filtro, startDate, endDate, profile.currentCompany[tabId()]]);

  useEffect(() => {
    dispatch(
      getMyHistory(
        pageItens,
        filtro,
        startDate && startDate.format('YYYY-MM-DD'),
        endDate && endDate.format('YYYY-MM-DD'),
      ),
    );
  }, [pageItens, filtro, startDate, endDate, profile.currentCompany[tabId()]]);

  const handleDatesChange = ({ startDate, endDate }: IHandleDatesChange) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };
  return (
    <div className="page-container">
      {!profile.representant &&
        (!allowedSaleSituations.includes(profile.sale_situation) || profile.paralyzed) && (
          <BlockedSubscription paralyzed={profile.paralyzed} />
        )}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        profile.represented.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        !allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
      {((!profile.representant &&
        !profile.paralyzed &&
        allowedSaleSituations.includes(profile.sale_situation)) ||
        (profile.representant &&
          allowedSaleSituations.includes(
            profile?.represented?.filter(
              (company) => company.id === profile.currentCompany[tabId()],
            )[0]?.sale_situation_name,
          ) &&
          !profile.represented.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.paralisado)) && (
        <MyHistoryPage
          setPageFollowup={setPageFollowup}
          pageFollowup={pageFollowup}
          setPageItens={setPageItens}
          pageItens={pageItens}
          setFiltro={setFiltro}
          filtro={filtro}
          endDate={endDate}
          startDate={startDate}
          handleDatesChange={handleDatesChange}
        />
      )}
    </div>
  );
};
export default MyHistory;
